import { render } from "./google-o-auth.vue?vue&type=template&id=483d8478&scoped=true"
import script from "./google-o-auth.vue?vue&type=script&lang=js"
export * from "./google-o-auth.vue?vue&type=script&lang=js"

import "./google-o-auth.vue?vue&type=style&index=0&id=483d8478&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483d8478"]])

export default __exports__